import React from 'react';
import './CEOSection.css';
import ceoImage from '../assets/ceo.png';

const CEOSection = () => {
  return (
    <section className="mc-section" id="ceo">
      <div className="mc-ceo-section">
        <div className="mc-ceo-image-container">
          <img src={ceoImage} alt="CEO" className="mc-ceo-img" />
          <div className="mc-ceo-badge">
            11+ Years Industry Experience
          </div>
        </div>
        <div className="mc-ceo-content">
          <h2 className="mc-ceo-title mc-gradient-accent">Meet Your Master</h2>
          <div>
            <h3 className="mc-ceo-name">Shashi Bagal</h3>
            <p className="mc-ceo-role">FOUNDER</p>
          </div>
          <blockquote className="mc-ceo-quote">
            "The AI revolution is moving incredibly fast. Our goal is to equip you with the practical, high-leverage skills needed to thrive in this new era."
          </blockquote>
          <p className="mc-ceo-desc">
            With over a decade of experience in machine learning and scalable system design, our founder directly orchestrated the curriculum. You are bypassing the traditional theoretical approach and getting straight to the tools and mental models that top companies rely on today.
          </p>

        </div>
      </div>
    </section>
  );
};

export default CEOSection;
